<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font skyBlue" colspan="3">Transactions</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Revenue</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">1,611</td>
                            <td class="end font">640</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Cost of sales</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">6,835</td>
                            <td class="end font">1,814</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue" colspan="3">Key management compensation</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Salaries and other short term employee benefits</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">3,517</td>
                            <td class="end font">3,937</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Post-employment benefits</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">1,461</td>
                            <td class="end font">1,403</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue" colspan="3">Balances</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Trade receivables (due from parent company)</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">3,823</td>
                            <td class="end font">3,169</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Trade payables (due from parent company)</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">6,302</td>
                            <td class="end font">4,521</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font skyBlue" colspan="3">المعاملات</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">الإيرادات</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">1,611</td>
                            <td class="end font">640</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">تكلفة المبيعات</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">6,835</td>
                            <td class="end font">1,814</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue" colspan="3">مكافأة الإدارة العليا</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">رواتب ومنافع أخرى قصيرة الأجل للموظفين</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">3,517</td>
                            <td class="end font">3,937</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">مكافأة نهاية الخدمة للموظفين</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">1,461</td>
                            <td class="end font">1,403</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue" colspan="3">الأرصدة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">ذمم تجارية مدينة (مستحق من الشركة الأم)</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">3,823</td>
                            <td class="end font">3,169</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">ذمم تجارية دائنة (مستحق للشركة الأم)</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">6,302</td>
                            <td class="end font">4,521</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>